import { render, staticRenderFns } from "./RouterMenu.vue?vue&type=template&id=4d94f9e1&scoped=true&"
import script from "./RouterMenu.vue?vue&type=script&lang=js&"
export * from "./RouterMenu.vue?vue&type=script&lang=js&"
import style0 from "./RouterMenu.vue?vue&type=style&index=0&id=4d94f9e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d94f9e1",
  null
  
)

export default component.exports